import { PharmacTruncate } from '@pharmac/ui'

export const createTicketAttachmentFilename = (originalFilename: string) => {
  const filename = originalFilename.substring(0, originalFilename.lastIndexOf('.'))
  const tooLong = filename.length > 7

  const ext = originalFilename.substring(originalFilename.lastIndexOf('.') + (tooLong ? 1 : 0))

  return PharmacTruncate(filename, 7) + ext
}
